import React, { Component } from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import InputGroup from "react-bootstrap/InputGroup"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import Multiselect from "multiselect-react-dropdown"
import "bootstrap/dist/css/bootstrap.min.css"

import "../App.css"
import "../Utils.css"
import "./Management.css"
import "./Lenders.css"
import * as com from "../Common"
import { lender } from "../State"
import { toInteger } from "lodash"
import { message, Space, Popconfirm, Input, Divider, Table, Select, Checkbox } from 'antd'
import { InfoCircleTwoTone, SearchOutlined } from "@ant-design/icons"
import { DeleteTwoTone } from "@ant-design/icons"
import PlanModal from "../planModal"
import UpgradeToBusinessModal from "./UpgradeToBusinessModal"
import AddLendersModal from "./AddLendersModal"
import LenderConfigDrawer from "./LenderConfigDrawer"
import { buildLenderConfig, normalizeLenderFees, statesUsedByOtherRows, maxCompensationZeroesPay } from "./lenderConfig"

import { useSelector, useDispatch, connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'
// import EditLenderModal from './EditLenderModal';

const deepcopy = require("deepcopy")
const mapStateToProps = (state) => {

    return {
        subscriptionReducer: state.subscriptionReducer.currentInfo,
        manager: state.manager
    }
}
const mapDispatchToProps = (dispatch) => ({
    updateChangeOpen: (application) => {

        dispatch({
            type: "OPEN",
            data: application,
        })
    },
    updateSelectLender: (application) => {

        dispatch({
            type: "SELECT_LENDERS",
            data: application,
        })
    },
    updateLender: (application) => {

        dispatch({
            type: "LENDERS_LENGTH",
            data: application,
        })
    }

})
const emptyrule = {
    selectedRule: "",
    value: "",
    maxrule: "",
    minrule: "",
    minoperator: "less",
    maxoperator: "less",
    action: "",
    selectedEnum: [],
    operator: null,
    ref: null,
}
const emptypromotion = {
    selectedPromotion: "",
    value: "",
    maxrule: "",
    minrule: "",
    minoperator: "less",
    maxoperator: "less",
    message: "",
    selectedEnum: [],
    operator: null,
    ref: null,
}

const lendersLogoMap = {}
const DEFAULT_LENDER_LOGO = "/images/lendersLogo/DefaultLender_logo.svg"
// only used when /data/loanlimits hasn't answered yet, so the add-lender state picker isn't empty
const US_STATE_ABBRS = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS",
    "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC",
    "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
]
class Lenders extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isModalOpen: false,
            allenders: [],
            customerlenders: [],
            selectedid: null,
            validated: false,
            minimumClosingCostPercentage: "",
            maximumClosingCostPercentage: "",
            show: false,
            showcopy: false,
            showpromotion: false,
            mode: "add",
            showmodalvalidated: false,
            rules: [deepcopy(emptyrule)],
            promotions: [deepcopy(emptypromotion)],
            selectedEnum: [],
            modalcopyvalidated: false,
            modalpromotionvalidated: false,
            lendercache: {},
            showLendersNotInListModal: false,
            isMobile: window.innerWidth < 576,
            showEdit: false,
            editTarget: [],
            modalAddLenderValidated: false,
            selectedLenders: [],
            savedLenders: [],
            expandedRowKeys: [],
            hoveredRowIndex: null,
            isNarrowScreen: window.innerWidth < 1400,
            loanLimits: {},
            isInputSearchChanged: false,
            searchKeywords: "",
            showManager: false,
            showEditModal: false,
            currentEditLender: null,
            tableLoading: false, // 添加 tableLoading 状态
            isUpgradePlanModalOpen: false,
            justInsertedLenders: [],
            addLendersSaving: false,
            editingLenderKey: null,
            lenderEditDirty: false,
        }
        this.state.rules[0].ref = React.createRef()
        this.state.promotions[0].ref = React.createRef()
        this.lendersid = {}
        // this.form = React.createRef();
        this.formRefs = {}
        this.modal = React.createRef()
        this.promotionmodal = React.createRef()
        this.modalcopy = React.createRef()
        this.addLenderModal = React.createRef()

    }

    search_svg = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="14.5" cy="14.5" r="7" stroke="#6E6E70" stroke-width="2"/>
                <rect width="2" height="5" rx="1" transform="matrix(-0.707107 0.707107 0.707107 0.707107 19.9141 18.5)" fill="#6E6E70"/>
            </svg>
        )
    }

    close_svg = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16.2421 6.34383C16.6326 5.9533 17.2658 5.9533 17.6563 6.34383C18.0468 6.73435 18.0468 7.36751 17.6563 7.75804L7.75683 17.6575C7.36631 18.0481 6.73314 18.0481 6.34262 17.6575C5.95209 17.267 5.95209 16.6338 6.34262 16.2433L16.2421 6.34383Z" fill="#6E6E70"/>
                <path d="M17.6562 16.246C18.0467 16.6365 18.0467 17.2697 17.6562 17.6602C17.2657 18.0508 16.6325 18.0508 16.242 17.6602L6.34247 7.76074C5.95194 7.37021 5.95194 6.73705 6.34247 6.34652C6.73299 5.956 7.36616 5.956 7.75668 6.34652L17.6562 16.246Z" fill="#6E6E70"/>
            </svg>
        )
    }

    getCustomerLenders = () => {
        this.setState({ tableLoading: true }); // 开始加载时设置为 true
        
        let token = sessionStorage.getItem("ZeitroA")
        fetch("/data/getcustomerlenders", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then((js) => {
                    if (js.Status !== "OK") {
                        alert("Error!")
                    } else {
                        this.setState({
                            minimumClosingCostPercentage: js.Config.MinClosingCostPercent,
                            maximumClosingCostPercentage: js.Config.MaxClosingCostPercent,
                        })
                        if (js.Lenders) {
                            // connected lenders show regardless of hidden (hidden only gates the add-lender catalog)
                            js.Lenders.forEach((x) => {
                                if (!x.Config) {
                                    x.Config = {}
                                } else {
                                    x.Config = JSON.parse(x.Config)
                                }
                                
                                // Ensure all existing lender fees have feeFormat property
                                if (x.Config.lenderfees && Array.isArray(x.Config.lenderfees)) {
                                    x.Config.lenderfees.forEach(fee => {
                                        if (!fee.feeFormat) {
                                            fee.feeFormat = 'flat' // Default to flat fee format for existing fees
                                        }
                                    })
                                }
                            })

                            this.props.updateLender(js.Lenders.filter(item => item.Active).length)

                            this.resetLenderIDs(js.Lenders)
                        }
                    }
                })
            })
            .catch(function (err) {
                console.log("Fetch Error :-S", err)
            })
            .finally(() => {
                this.setState({ tableLoading: false }); // 无论成功失败都设置为 false
            });
    };
    getPreviousSavedStaus = (lenders) => {
        let prviousSavedLenders = deepcopy(this.state.savedLenders)
        lenders.forEach((x) => {
            if (x.Active) {
                prviousSavedLenders.push(x.name)
            }
        })
        this.setState({ savedLenders: prviousSavedLenders })
    }

    resetLenderIDs = (lenders) => {
        this.lendersid = []
        lenders.forEach((x) => {
            if (x.Active) {
                this.lendersid[x.id] = true
            }
        })
        // lenders = lenders.sort((x, y) => {
        //   return x.name[0] > y.name[0] ? 1 : -1;
        // });
        this.setState({ customerlenders: lenders })
        // if (lenders.length > 0 ) {
        //     this.setState({ selectedid: lenders[0].id })
        // }
    };

    getLoanLimits = () => {
        fetch("/data/loanlimits")
            .then((res) => {
                if (!res.ok) {

                    throw Error(res.statusText)
                }
                return res.json()
            })
            .then((res) => {
                this.setState({ loanLimits: res })
            })
            .catch((err) => {
                console.error(err)
            })
    }

    getLenders = () => {
        this.setState({ tableLoading: true }); // 开始加载时设置为 true
        
        let token = sessionStorage.getItem("ZeitroA")
        fetch("/data/getalllenders", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then((js) => {
                    if (js.Status !== "OK") {
                        alert("Error!")
                    } else {
                        let lenders = js.Lenders.sort((x, y) => {
                            return x.name[0] > y.name[0] ? 1 : -1
                        })
                        this.setState({ allenders: lenders })
                        this.getCustomerLenders()
                    }
                })
            })
            .catch(function (err) {
                console.log("Fetch Error :-S", err)
            })
            .finally(() => {
                this.setState({ tableLoading: false }); // 无论成功失败都设置为 false
            });
    };
    componentDidMount() {
        if (this.props.statsigSource === 'management') {
            track(STATSIG.COMMON.VIEW, PAGE.LENDERS, { page: PAGE.LENDERS })
        }
        this.getLenders()
        this.getLoanLimits()
        if (this.props.isManager) {
            this.props.updateSelectLender(false)
            this.setState({ showManager: true })
            // console.log();

            // this.props.setTableItems(this.state.customerlenders.length)
        }

    }
    sendLenders(name) {
        this.postLenders(name).catch(function (err) {
            console.log("Fetch Error :-S", err)
            alert("Error!")
        })
    }
    // Same payload as sendLenders, but rejects on failure so callers can wait for
    // the save before closing a dialog / reporting success.
    postLenders(name) {
        let token = sessionStorage.getItem("ZeitroA")
        let b = []
        let lendersCopy = deepcopy(this.state.customerlenders)
        const lenderId = (this.state.customerlenders.find((x) => x.name === name) || {}).id
        for (let l of lendersCopy) {
            if (l.Active) {
                b.push(l)
            }
        }
        // reset config to string
        b.forEach((x) => {
            if (x.Config.closeover !== null) {
                x.Config.closeover = com.safeParseFloat(x.Config.closeover).toString()
            }
            normalizeLenderFees(x.Config)
            x.Config = JSON.stringify(x.Config)
            if (x.name === name) {
                x.Lastedit = new Date().toISOString()
            }
        })
        let body = {
            Status: "OK",
            Lenders: b,
            Config: {
                MinClosingCostPercent: this.state.minimumClosingCostPercentage,
                MaxClosingCostPercent: this.state.maximumClosingCostPercentage,
            },
        };
        return fetch("/data/postlenders", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
            body: JSON.stringify(body),
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log("Looks like there was a problem: ", response)
                    throw new Error("/data/postlenders returned status " + response.status)
                }
                // Examine the text in the response
                return response.json()
            })
            .then((js) => {
                if (js.Status !== "OK") {
                    throw new Error("/data/postlenders returned " + js.Status)
                }
                // callers that save without naming a lender (the add-lender flow, which
                // saves several at once) report their own events instead
                if (name !== undefined) {
                    const justInserted = this.state.justInsertedLenders || []
                    if (justInserted.includes(name)) {
                        this.trackLendersChange(STATSIG.LENDERS.INSERT, lenderId)
                        this.setState({
                            justInsertedLenders: justInserted.filter((n) => n !== name),
                        })
                    } else {
                        this.trackLendersChange(STATSIG.LENDERS.UPDATE, lenderId)
                    }
                }
                // alert("Lenders updated successfully!")
                if (this.state.savedLenders.length > 0) {
                    if (typeof this.props.hasSavedLenders === 'function') {
                        this.props.hasSavedLenders(true)
                    }
                }
            })
    }
    trackLendersChange(event, lenderId) {
        if (this.props.statsigSource !== 'management' && this.props.statsigSource !== 'rates') return
        const value = `lender_id-${lenderId}`
        track(event, value, { lender_id: value })
    }
    trackMgmtLenders(event, value, metadata) {
        if (this.props.statsigSource !== 'management') return
        if (value === undefined) {
            track(event)
            return
        }
        track(event, value, metadata)
    }
    deleteLender(id) {
        let token = sessionStorage.getItem("ZeitroA")
        let body = { ID: id }

        fetch("/data/deletelender", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
            body: JSON.stringify(body),
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then((js) => {
                    if (js.Status !== "OK") {
                        alert("Error!")
                    } else {
                        this.trackLendersChange(STATSIG.LENDERS.DELETE, id)

                        if (this.state.savedLenders.length < 1) {
                            if (typeof this.props.hasSavedLenders === 'function') {
                                this.props.hasSavedLenders(false)
                            }
                        }
                    }
                })
            })
            .catch(function (err) {
                console.log("Fetch Error :-S", err)
            })
    }
    handleTableFormSubmit = (record) => (event) => {
        const form = this.formRefs[record.name + "_table"].current
        if (form.reportValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
            this.setState({ validated: true })
            return false
        }
        // the calculator reads lender settings on every quote (no cache), so a
        // saved change shows up on the next search
        this.postLenders(record.name)
            .then(() => message.success("Lender settings saved. New quotes use them right away."))
            .catch(function (err) {
                console.log("Fetch Error :-S", err)
                alert("Error!")
            })
        let targets = deepcopy(this.state.editTarget)
        let expandedRowKeys = deepcopy(this.state.expandedRowKeys)
        targets = targets.filter((x) => x !== record.name)
        expandedRowKeys = expandedRowKeys.filter((x) => x !== record.key)
        // a successful save closes the editor dialog
        this.setState({ expandedRowKeys: expandedRowKeys, editingLenderKey: null, lenderEditDirty: false })
        if (targets.length === 0) {
            this.setState({ showEdit: false, editTarget: targets })
        } else {
            this.setState({ editTarget: targets })
        }

        event.preventDefault()
        event.stopPropagation()
        return false
    }

    handleSearch = (value) => {
        setTimeout(() => {
            if (!this.state.isInputSearchChanged) {
                this.setState({ searchKeywords: value })
            }
        }, 100)
    }
    handleSearchChange = (e) => {
        this.setState({ isInputSearchChanged: true, searchKeywords: e.target.value.trim() })
        setTimeout(() => {
            this.setState({ isInputSearchChanged: false })
        }, 200)
    }
    handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault()
            this.handleSearch(event.target.value)
        }
    }

    // Lenders the customer can still add: everything they are not already connected to,
    // minus the ones hidden for their account.
    getAvailableLenders = () => {
        let lenders = this.state.allenders.filter((x) => undefined === this.lendersid[x.id])
        lenders = lenders.sort((x, y) => (x.name[0] > y.name[0] ? 1 : -1))
        if (com.getCustomerId() === "gmcc") {
            return lenders.filter((x) => x.lender !== "USBank" && x.lender !== "TMS" && x.lender !== "ChenoaFund")
        }
        if (com.getCustomerId() === "star") {
            return lenders.filter((x) => x.lender !== "FCB")
        }
        return lenders.filter((x) => x.lender !== "USBank" && x.lender !== "TMS" && x.lender !== "ChenoaFund" && x.lender !== "FCB")
    }

    getStateOptions = () => {
        let options = Object.keys(this.state.loanLimits)
            .map((x) => ({ label: com.capitalize(x), value: com.convertStateToAbbr(x) }))
            .filter((x) => x.value)
        if (options.length === 0) {
            // loan limits not back yet — fall back so the state picker is never empty
            options = US_STATE_ABBRS.map((abbr) => ({
                label: com.mapAbbrFullName[abbr] || abbr,
                value: abbr,
            }))
        }
        return options.sort((a, b) => a.label.localeCompare(b.label))
    }

    // Step 2 of the add-lender flow: attach the configured lenders and persist them
    // right away, so there is no separate "remember to press Save" step.
    addAndSaveLenders = (payload) => {
        let catalog = {}
        this.getAvailableLenders().forEach((x) => { catalog[x.name] = x })

        let now = new Date().toISOString()
        let lendersCopy = deepcopy(this.state.customerlenders)
        let lendersOnTop = []
        let addedNames = []

        payload.forEach(({ name, config }) => {
            let entry = catalog[name]
            if (!entry) return
            // a lender the customer used before keeps its historical rules / promotions
            let previous = lendersCopy.find((l) => l.id === entry.id)
            let cached = this.state.lendercache[entry.id]
            let previousConfig = (previous && previous.Config) || (cached && cached.Config) || null
            lendersOnTop.push({
                id: entry.id,
                name: entry.name,
                lender: entry.lender,
                Config: buildLenderConfig(config, previousConfig),
                Active: true,
                Lastedit: now,
            })
            addedNames.push(entry.name)
        })

        if (addedNames.length === 0) {
            this.setState({ showAdd: false })
            return
        }

        lendersCopy = lendersCopy.filter((l) => !lendersOnTop.some((t) => t.id === l.id))
        // keep newly added lenders on top
        lendersCopy = [...lendersOnTop, ...lendersCopy]

        // snapshot so a failed save doesn't leave lenders looking connected
        let rollback = { lenders: this.state.customerlenders, ids: this.lendersid, saved: this.state.savedLenders }

        this.lendersid = []
        lendersCopy.forEach((x) => { if (x.Active) this.lendersid[x.id] = true })

        this.setState({
            customerlenders: lendersCopy,
            savedLenders: [...this.state.savedLenders, ...addedNames],
            addLendersSaving: true,
        }, () => {
            // Promise.resolve so a synchronous throw inside postLenders still lands in catch
            Promise.resolve()
                .then(() => this.postLenders())
                .then(() => {
                    lendersOnTop.forEach((x) => this.trackLendersChange(STATSIG.LENDERS.INSERT, x.id))
                    this.props.updateLender(lendersCopy.filter((item) => item.Active).length)
                    this.setState({ showAdd: false, addLendersSaving: false, selectedLenders: [] })
                    message.success(
                        addedNames.length + " lender" + (addedNames.length === 1 ? "" : "s") + " added and saved"
                    )
                })
                .catch((err) => {
                    console.log("Fetch Error :-S", err)
                    this.lendersid = rollback.ids
                    this.setState({
                        customerlenders: rollback.lenders,
                        savedLenders: rollback.saved,
                        addLendersSaving: false,
                    })
                    message.error("Couldn't save these lenders. Please try again.")
                })
        })
    }

    render() {

        let addLenders = () => {

            let handleSelectLenders = (name) => {
                if (selectedLenders.includes(name)) {
                    selectedLenders = selectedLenders.filter((y) => y !== name)
                } else {
                    selectedLenders.push(name)
                }
                this.setState({ selectedLenders: selectedLenders })
            }
            let selectedLenders = deepcopy(this.state.selectedLenders)
            let out = []
            let lenders = this.getAvailableLenders()
            lenders.forEach((x) => {
                out.push({
                    name: x.name,
                    children:
                        <div className={`lenderItem ${selectedLenders.includes(x.name) ? "selectedLenders" : "unselectedLenders"}`} onClick={() => handleSelectLenders(x.name)}>
                            <div style={{display: "flex", alignItems: "center"}}>
                                <img className="lendersLogo" src={Object.keys(lendersLogoMap).includes(x.name) ? lendersLogoMap[x.name] : DEFAULT_LENDER_LOGO} />
                                {/* <img className="lendersLogo" src={DEFAULT_LENDER_LOGO}/> */}
                                <div style={{ fontWeight: "500", overflow: 'hidden', fontSize: "16px", marginLeft: "8px"}}>{x.name}</div>
                            </div>
                            <Checkbox className="lenderCheckbox" checked={selectedLenders.includes(x.name)} />
                        </div>,
                })
            })
            let result = []
            let noSearchResult = false
            out.forEach((x) => {
                if (x.name.toLowerCase().includes(this.state.searchKeywords.toLowerCase())) {
                    result.push(x.children)
                }
            })
            if (result.length === 0) {
                noSearchResult = true
            }

            return <div className="">
                <div className="lendersInputLabel">Select the lenders you'd like to add</div>
                <div className={this.props.showManager ? 'showManager  lendersInput' : 'lendersInput'}>
                    {this.props.manager ? <Space.Compact size="large" style={{ width: '100%' }}>
                        <Input className="lendersInputSearch" prefix={this.search_svg()} style={{ width: '100%' }} value={this.state.searchKeywords} placeholder="Search lender name"
                            onSearch={this.handleSearch}
                            onChange={this.handleSearchChange}
                            onKeyPress={this.handleKeyPress} />

                    </Space.Compact> : <Input.Search
                        placeholder="Search lender name"
                        style={{ height: "44px" }}
                        value={this.state.searchKeywords}
                        onSearch={this.handleSearch}
                        onChange={this.handleSearchChange}
                        onKeyPress={this.handleKeyPress}
                    />}

                </div>
                {
                    this.props.manager ? <></> : <Row style={{ display: "flex", justifyContent: "right", marginBottom: "10px" }}>
                        <div className="revertSearch" onClick={() => this.setState({ searchKeywords: "" })}>Clear Search</div>
                    </Row>
                }
                <hr className="lendersHr"/>
                {noSearchResult ? (
                    <div className="d-flex align-items-center justify-content-center mt-3">
                        <div style={{ color: "#586570", fontSize: "18px", fontWeight: "500" }}>No search result.</div>
                    </div>
                ) : (
                    <Row style={{ display: "flex", gap: "20px" }} className="lenderItems">
                        {result}
                    </Row>
                )}
            </div>
        }
        let selectLenders = () => {
            return (
                <div className="LendersHeader">
                    <Modal.Header >
                        <Modal.Title>
                            Select your lenders
                        </Modal.Title>
                    </Modal.Header>
                    <div className="lendersLine"></div>
                    <Form
                        className="addLenderModalForm"
                        ref={this.addLenderModal}
                        onSubmit={modalAddLenderSubmit}
                        noValidate
                        validated={this.state.modalAddLenderValidated}
                    >
                        <Modal.Body>
                            <div style={{ height: '70vh', overflowY: 'auto' }}>
                                {addLenders()}
                            </div>
                        </Modal.Body>

                        <Button className="addLenderButton" id="addLenderButton" type="submit" style={{ opacity: 0 }}>
                            Add
                        </Button>
                    </Form>

                </div>
            )

        }
        let setSelectedLender = (e) => {
            this.setState({ selectedid: parseInt(e.target.value) })
        }

        let handleSaveLender = (name, customerlenders_edit) => {
            let savedLenders = deepcopy(this.state.savedLenders)
            let customerlenders = deepcopy(this.state.customerlenders)
            customerlenders.forEach((x) => {
                if (x.name === name) {
                    x.Lastedit = new Date().toISOString()
                }
            })
            savedLenders.push(name)
            this.setState({ savedLenders: savedLenders, customerlenders: customerlenders })
            this.handleTableFormSubmit(customerlenders_edit)
        }

        let showLenders = (e) => {

            let convertEditTime = (time) => {
                let date = new Date(time)
                let day = String(date.getDate()).padStart(2, '0')
                let month = String(date.getMonth() + 1).padStart(2, '0')
                let year = date.getFullYear()
                return month + '/' + day + '/' + year
            }

            const feeSummary = (fee) => {
                const symbol = fee.feeFormat === "percentage" ? "%" : "$"
                return fee.feeFormat === "percentage" ? `${fee.fee}${symbol}` : `${symbol}${fee.fee}`
            }

            const columns = [
                {
                    title: "Lender",
                    dataIndex: "name",
                    defaultsortOrder: "descend",
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    key: "name",
                    className: "lendersNameCol",
                    render: (text, record) => (
                        <div className="lendersRowName">
                            <img className="lendersLogo" src={Object.keys(lendersLogoMap).includes(record.name) ? lendersLogoMap[record.name] : DEFAULT_LENDER_LOGO} alt="" />
                            <div style={{ minWidth: 0 }}>
                                <div className="lendersRowNameText">{record.name}</div>
                                <div className="lendersRowSub">
                                    {com.LenderRelationshhip[record.config.correspondentLender]
                                        ? com.LenderRelationshhip[record.config.correspondentLender].name
                                        : "Broker"}
                                </div>
                            </div>
                        </div>
                    ),
                },
                {
                    title: "Compensation",
                    width: "160px",
                    dataIndex: "compensation",
                    render: (text, record) => {
                        const flat = com.safeParseFloat(record.config.compensationFlatFee)
                        return (
                            <div className="lendersRowText">
                                {record.compensation || 0}%{flat ? ` + $${com.commaizeFloat(flat)}` : ""}
                                {maxCompensationZeroesPay(record.config) && (
                                    <span
                                        className="lendersCompZeroChip"
                                        title="Max compensation is $0, so this lender pays you nothing. Open the lender to change it."
                                    >
                                        Max $0
                                    </span>
                                )}
                            </div>
                        )
                    },
                },
                {
                    title: "Origination fee",
                    dataIndex: "lenderfees",
                    width: "260px",
                    render: (text, record) => {
                        const fees = record.lenderfees || []
                        const base = fees.find((f) => !f.states || f.states.length === 0)
                        const overrides = fees.filter((f) => f.states && f.states.length > 0)
                        return (
                            <div>
                                <div className="lendersRowText">
                                    {base ? `${feeSummary(base)} · all states` : "No default fee"}
                                </div>
                                {overrides.length > 0 && (
                                    <div className="lendersRowSub">
                                        {overrides.length} state override{overrides.length > 1 ? "s" : ""}
                                        {" ("}
                                        {overrides.map((o) => o.states.join(", ")).join("; ")}
                                        {")"}
                                    </div>
                                )}
                            </div>
                        )
                    },
                },
                {
                    title: "Last edited",
                    width: "140px",
                    dataIndex: "lastedit",
                    defaultsortOrder: "descend",
                    sorter: (a, b) => new Date(a.lastedit) - new Date(b.lastedit),
                    defaultsorted: true,
                    render: (text, record) => (
                        <div className="lendersRowSub">
                            {record.lastedit == undefined || !record.lastedit ? "-" : convertEditTime(record.lastedit)}
                        </div>
                    ),
                },
                {
                    title: "",
                    dataIndex: "actions",
                    width: "88px",
                    render: (text, record, index) => (
                        <div className="lendersRowActions" style={{ visibility: this.state.hoveredRowIndex === index ? "visible" : "hidden" }}>
                            <button type="button" title="Edit" className="lendersRowAction" onClick={(e) => { e.stopPropagation(); handleExpand(record) }}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M17 3C17.5 2.5 18.5 2.5 19 3L21 5C21.5 5.5 21.5 6.5 21 7L8 20L3 21L4 16L17 3Z" stroke="#71717A" strokeWidth="2" strokeLinejoin="round"/></svg>
                            </button>
                            <button type="button" title="Remove" className="lendersRowAction lendersRowActionDanger" onClick={(e) => { e.stopPropagation(); tableRemoveLender(record) }}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M4 7H20M9 7V5C9 4.4 9.4 4 10 4H14C14.6 4 15 4.4 15 5V7M6 7L7 20C7 20.6 7.4 21 8 21H16C16.6 21 17 20.6 17 20L18 7" stroke="#B13A3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </button>
                        </div>
                    ),
                }
            ]

            let closeLenderEditor = () => {
                this.setState({ editingLenderKey: null, lenderEditDirty: false })
            }

            let handleExpand = (record) => {
                if (this.state.editingLenderKey === record.key) {
                    closeLenderEditor()
                    return
                }
                let targets = deepcopy(this.state.editTarget)
                if (!targets.includes(record.name)) targets.push(record.name)
                this.setState({ showEdit: true, editTarget: targets, editingLenderKey: record.key, lenderEditDirty: false })
            }

            let tableRemoveLender = (lender) => {
                if (
                    window.confirm(
                        "Are you sure you want to delete " +
                        lender.name +
                        "? The operation is irreversible."
                    )
                ) {
                    let lenders = []
                    this.state.customerlenders.forEach((y) => {
                        if (y.id === lender.id) {
                            return
                        }
                        lenders.push(y)
                    })
                    let cac = deepcopy(this.state.lendercache)
                    cac[lender.id] = lender.lenderObj
                    this.setState({ lendercache: cac })
                    this.deleteLender(lender.id)
                    this.resetLenderIDs(lenders)
                    this.props.updateLender(lenders.filter(item => item.Active).length)
                }
            }

            const getStates = () => {
                let options = []
                let keys = Object.keys(this.state.loanLimits)
                keys.forEach((x) => {
                    options.push({ label: com.capitalize(x), value: com.convertStateToAbbr(x) })
                })
                return options
            }

            let tableItems = []
            for (let x of this.state.customerlenders) {
                if (x.Active === true) {
                    if (!x.Config.lenderfees || x.Config.lenderfees.length <1){
                        x.Config.lenderfees = []
                        x.Config.lenderfees.push({
                            fee: 0,
                            feeFormat: 'flat', // Default to flat fee format
                            states: [],
                            mortgageTypes: [],
                        })
                    }
                    let displayRelationship = (key, i) => {
                        let rel = com.LenderRelationshhip[key]
                        return (
                            <option
                                value={key}
                                selected={key === x.Config.correspondentLender}
                                key={"relationship+" + i}
                            >
                                {rel.name}
                            </option>
                        )
                    }

                    let onCompensation = (e) => {
                        x.Config.compensation = e.target.value
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onCompensationFlatFee = (e) => {
                        x.Config.compensationFlatFee = parseFloat(e.target.value)
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onMinCompensation = (e) => {
                        x.Config.minimumCompensation = e.target.value
                        if (x.Config.minimumCompensation === "")
                            x.Config.minimumCompensation = null
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onMaxCompensation = (e) => {
                        x.Config.maximumCompensation = e.target.value
                        if (x.Config.maximumCompensation === "")
                            x.Config.maximumCompensation = null
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onCloseover = (e) => {
                        x.Config.closeover = e.target.value
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onMincost = (e) => {
                        x.Config.minimumClosingCostPercentage = e.target.value
                        if (x.Config.minimumClosingCostPercentage === "")
                            x.Config.minimumClosingCostPercentage = null
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onMaxcost = (e) => {
                        x.Config.maximumClosingCostPercentage = e.target.value
                        if (x.Config.maximumClosingCostPercentage === "")
                            x.Config.maximumClosingCostPercentage = null
                        this.setState({ customerlenders: this.state.customerlenders })
                    }
                    let onCorrespondent = (e) => {
                        x.Config.correspondentLender = e.target.value
                        this.setState({ customerlenders: this.state.customerlenders })
                    }

                    let showLenderFees = (y, i) => {
                        let removeSlice = () => {
                            x.Config.lenderfees.splice(i, 1)
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let addSlice = () => {
                            x.Config.lenderfees.push({
                                fee: 0,
                                feeFormat: 'flat', // Default to flat fee format
                                states: [],
                                mortgageTypes: [],
                            })
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let onFee = (e) => {
                            let value = e.target.value
                            // Remove any non-numeric characters except decimal point
                            value = value.replace(/[^0-9.]/g, '')
                            y.fee = parseFloat(value) || 0
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let onFeeFormat = (value) => {
                            y.feeFormat = value
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let onStates = (value) => {
                            y.states = value
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        // A state can only carry one origination fee, so the ones already
                        // claimed by another row are greyed out instead of silently
                        // producing two conflicting fees for the same state.
                        let statesUsedElsewhere = statesUsedByOtherRows(x.Config.lenderfees, i)
                        let stateOptions = getStates().map((o) => (
                            statesUsedElsewhere.has(o.value)
                                ? { ...o, disabled: true, label: o.label + " (already used)" }
                                : o
                        ))

                        return (
                            <>
                                <Row
                                    key={"card" + x.lender + i}
                                    className=" m-2 p-0"
                                >
                                    <Col xs="auto" className="p-2 formInputFees">
                                        <Form.Group controlId={"idfee" + x.lender + i}>
                                            <Form.Label className="text-left">
                                                Lender Origination Fee:
                                            </Form.Label>

                                                                                        <div className="unified-fee-input">
                                                <Select
                                                    size="sm"
                                                    defaultValue={y.feeFormat || 'flat'}
                                                    onChange={onFeeFormat}
                                                    options={[
                                                        { value: 'flat', label: 'Flat fee' },
                                                        { value: 'percentage', label: 'Percent of loan' }
                                                    ]}
                                                    style={{ width: "9em" }}
                                                />
                                                <div className="fee-symbol">
                                                    {y.feeFormat === 'percentage' ? '%' : '$'}
                                                </div>
                                                <Form.Control
                                                    size="sm"
                                                    name={"idfee" + x.lender + i}
                                                    required
                                                    value={y.fee || ''}
                                                    onChange={onFee}
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    className="fee-input"
                                                    style={{ width: "6em" }}
                                                    placeholder={y.feeFormat === 'percentage' ? "0.00" : "0.00"}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col className="p-2 formInputStates">
                                        <Form.Group controlId={"states" + i} className="text-left" style={{ display: "flex", flexDirection: "column" }}>
                                            <Form.Label className="text-left" style={{ color: "white" }}>States:</Form.Label>
                                            {/* <Form.Control
                        isValid={false}
                        size="sm"
                        required
                        name={"states" + i}
                        type="text"
                        value={y.states.join(",")}
                        onChange={onStates}
                        pattern="^[\w,]*$"
                        style={{height:"50px"}}
                        placeholder="State(s) of this lender origination fee (e.g. CA, TX)"
                      />
                      <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid">
                        Please provide states.
                      </Form.Control.Feedback> */}

                                            <Select
                                                mode="multiple"
                                                allowClear
                                                // controlled, so removing a state here frees it up in the other fee rows
                                                value={y.states}
                                                onChange={onStates}
                                                options={stateOptions}
                                                placeholder="Select states for this lender origination fee"
                                                className="lenderFeeStates"
                                            />

                                        </Form.Group>
                                    </Col>
                                    <Col
                                        xs="auto"
                                        as="div"
                                        className="text-right d-flex align-items-center px-0 py-0"
                                    >
                                        <img className="addFeeIcon" src="/images/addIconCircle.png" onClick={addSlice} />
                                        {x.Config.lenderfees.length > 1 ? (
                                            <img className="removeFeeIcon" src="/images/removeIconCircle.png" onClick={removeSlice} />
                                        ) : (
                                            ""
                                        )}
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                    let displaySubRule = (rule) => {
                        let displayValue = (key) => {
                            switch (com.RuleSet[key].typ) {
                                case "minmax":
                                    return (
                                        <span className="text-bold">
                                            {com.operatorInout[rule[key].operator]} [{" "}
                                            {rule[key].value[0]}{" "}
                                            {com.operatorMap[rule[key].minoperator]}{" "}
                                            {com.RuleSet[key].name}{" "}
                                            {com.operatorMap[rule[key].maxoperator]}{" "}
                                            {rule[key].value[1]} ]{" "}
                                        </span>
                                    )
                                case "bool":
                                    return (
                                        <span className="text-bold">
                                            {com.operatorBool[rule[key].operator]}{" "}
                                        </span>
                                    )

                                case "value":
                                    switch (com.RuleSet[key].values) {
                                        case "bool":
                                            return (
                                                <span className="text-bold">{rule[key].operator} </span>
                                            )
                                        case "dollar":
                                            return (
                                                <span className="text-bold">
                                                    {" "}
                                                    {com.operatorMap[rule[key].operator]} $
                                                    {com.commaizeFloat(rule[key].value)}
                                                </span>
                                            )
                                        default:
                                            return (
                                                <span className="text-bold">
                                                    {com.operatorMap[rule[key].operator]}{" "}
                                                    {rule[key].value}
                                                </span>
                                            )
                                    }

                                case "enum":
                                    return (
                                        <span>
                                            {com.operatorEnum[rule[key].operator]}{" "}
                                            <span className="text-bold">
                                                {" "}
                                                [
                                                {rule[key].value
                                                    .map((x) => com.RuleSet[key].values[x])
                                                    .join(", ")}
                                                ]{" "}
                                            </span>
                                        </span>
                                    )
                                case "boolean":
                                    return ""
                            }
                            return rule[key]
                        }
                        let prepSubRule = (key) => {
                            return (
                                <Row key={"prepSubRule" + key}>
                                    <Col xs="auto" className="text-nowrap">
                                        <span className="text-bold">{com.RuleSet[key].name}</span>,
                                        if {displayValue(key)}
                                    </Col>
                                </Row>
                            )
                        }
                        let out = Object.keys(rule).map(prepSubRule)
                        return out
                    }
                    let displayEstablishedRule = (rules, j) => {
                        let removeeme = () => {
                            x.Config.rules.splice(j, 1)
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let edit = () => {
                            let staterules = []

                            if (x.Config.rules[j].adjustment != null) {
                                this.setState({
                                    action: "adjustment",
                                    adjustment: x.Config.rules[j].adjustment,
                                })
                            }

                            if (x.Config.rules[j].fail != null) {
                                this.setState({ action: "fail", fail: x.Config.rules[j].fail })
                            }

                            x.Config.rules[j].rules.forEach((y) => {
                                Object.keys(y).forEach((z) => {
                                    let r = {
                                        selectedRule: z,
                                    }

                                    switch (com.RuleSet[z].typ) {
                                        case "minmax":
                                            {
                                                r.minrule = y[z].value[0]
                                                r.maxrule = y[z].value[1]
                                                r.maxoperator = y[z].maxoperator
                                                r.minoperator = y[z].minoperator
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "enum":
                                            {
                                                r.selectedEnum = y[z].value.map((x) => {
                                                    return { id: x, name: com.RuleSet[z].values[x] }
                                                })
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "value":
                                            {
                                                r.value = y[z].value
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "bool":
                                            {
                                                r.value = true
                                                r.operator = y[z].operator
                                            }
                                            break
                                    }
                                    staterules.push(r)
                                })
                            })

                            this.setState({ rules: staterules })
                            this.setState({
                                show: true,
                                modalvalidated: false,
                                mode: "edit",
                                config: x.Config,
                                ruleindex: j,
                                conditionindex: x,
                            })
                        }
                        return (
                            <Col className="rulesWraper" md={12} key={"esrule" + j}>
                                <div className="rulecard d-flex mb-2">
                                    <div className="rulesHeader">
                                        <div>
                                            ADJUSTMENT
                                        </div>
                                    </div>
                                    {rules.rules.map(displaySubRule)}

                                    <Row>
                                        <Col xs="auto">
                                            {rules.adjustment != null ? (
                                                <span className="text-bold">
                                                    Adjustment: {rules.adjustment}%
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                            {rules.fail != null ? (
                                                <span
                                                    className="text-bold"
                                                    style={{ color: "#993333" }}
                                                >
                                                    Fail qualification!
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                                <div className="d-flex align-items-center text-right pr-1 ml-3" style={{ color: "#325CEB" }}>
                                    <i
                                        onClick={edit}
                                        className="fas fahover fa-edit aligh-top mr-2"
                                    ></i>
                                    <i
                                        onClick={removeeme}
                                        className="far fahover fa-minus-square aligh-top"
                                    ></i>
                                </div>
                            </Col>
                        )
                    }
                    let displayEstablishedRules = () => {
                        let rules = x.Config.rules

                        let rows = []
                        for (let i = 0; i < rules.length; i += 4) {
                            let cols = []
                            let j = i
                            for (; j < i + 4 && j < rules.length; j++) {
                                cols.push(displayEstablishedRule(rules[j], j))
                            }
                            if ((i + 1) % 4 !== 0) cols.push(<Col key={"cc" + j}></Col>)
                            rows.push(<Row key={"displayEstablishedRules" + i}>{cols}</Row>)
                        }
                        return rows
                    }
                    let displayEstablishedPromotion = (promotions, j) => {
                        let removeeme = () => {
                            x.Config.promotions.splice(j, 1)
                            this.setState({ customerlenders: this.state.customerlenders })
                        }
                        let edit = () => {
                            console.log(x.Config.promotions[j].conditions);
                            
                            let statepromotions = []

                            if (x.Config.promotions[j].message != null) {
                                this.setState({
                                    message: x.Config.promotions[j].message,
                                })
                            }
                            

                            x.Config.promotions[j].conditions.forEach((y) => {
                                Object.keys(y).forEach((z) => {
                                    let r = {
                                        selectedRule: z,
                                    }

                                    switch (com.RuleSet[z].typ) {
                                        case "minmax":
                                            {
                                                r.minrule = y[z].value[0]
                                                r.maxrule = y[z].value[1]
                                                r.maxoperator = y[z].maxoperator
                                                r.minoperator = y[z].minoperator
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "enum":
                                            {
                                                r.selectedEnum = y[z].value.map((x) => {
                                                    return { id: x, name: com.RuleSet[z].values[x] }
                                                })
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "value":
                                            {
                                                r.value = y[z].value
                                                r.operator = y[z].operator
                                            }
                                            break
                                        case "bool":
                                            {
                                                r.value = true
                                                r.operator = y[z].operator
                                            }
                                            break
                                    }
                                    statepromotions.push(r)
                                })
                            })


                            this.setState({ promotions: statepromotions })
                            this.setState({
                                showpromotion: true,
                                modalpromotionvalidated: false,
                                mode: "edit",
                                config: x.Config,
                                promotionindex: j,
                                conditionindex: x,
                            })
                        }
                        return (
                            <Col className="rulesWraper" md={12} key={"esrule" + j}>
                                <div className="rulecard d-flex  mb-2">
                                    <div className="rulesHeader">
                                        <div>
                                            PROMOTION
                                        </div>
                                    </div>
                                    {promotions.conditions.map(displaySubRule)}

                                    <Row>
                                        <Col xs="auto">
                                            <b>Promotion message: </b>{promotions.message}
                                        </Col>
                                    </Row>
                                </div>
                                <div className="d-flex align-items-center text-right pr-1 ml-3" style={{ color: "#325CEB" }}>
                                    <i
                                        onClick={edit}
                                        className="fas fahover fa-edit aligh-top mr-2"
                                    ></i>
                                    <i
                                        onClick={removeeme}
                                        className="far fahover fa-minus-square aligh-top"
                                    ></i>
                                </div>
                            </Col>
                        )
                    }
                    let displayEstablishedPromotions = () => {
                        let promotions = x.Config.promotions

                        let rows = []
                        for (let i = 0; i < promotions.length; i += 4) {
                            let cols = []
                            let j = i
                            for (; j < i + 4 && j < promotions.length; j++) {
                                cols.push(displayEstablishedPromotion(promotions[j], j))
                            }
                            if ((i + 1) % 4 !== 0) cols.push(<Col key={"cc" + j}></Col>)
                            rows.push(<Row key={"displayEstablishedPromotions" + i}>{cols}</Row>)
                        }
                        return rows
                    }
                    if (!this.formRefs[x.name + "_table"]) {
                        this.formRefs[x.name + "_table"] = React.createRef()
                    }
                    tableItems.push(
                        {
                            id: x.id,
                            lenderObj: x,
                            name: x.name,
                            key: "row_" + x.lender,
                            compensation: x.Config.compensation,
                            compminmax: { min: x.Config.minimumCompensation, max: x.Config.maximumCompensation },
                            closingcostminmax: { min: x.Config.minimumClosingCostPercentage, max: x.Config.maximumClosingCostPercentage },
                            lenderfees: x.Config.lenderfees,
                            config: x.Config,
                            lender: x.lender,
                            lastedit: x.Lastedit,
                            onCompensation: onCompensation,
                            onCompensationFlatFee: onCompensationFlatFee,
                            onMinCompensation: onMinCompensation,
                            onMaxCompensation: onMaxCompensation,
                            onMincost: onMincost,
                            onMaxcost: onMaxcost,
                            onCorrespondent: onCorrespondent,
                            showLenderFees: showLenderFees,
                            displayEstablishedRules: displayEstablishedRules,
                            displayEstablishedPromotions: displayEstablishedPromotions,
                            onCloseover: onCloseover,
                            displayRelationship: displayRelationship,
                            // actions: 0
                        }
                    )
                }
            }


            let handleSaveLender = (name) => {
                let savedLenders = deepcopy(this.state.savedLenders)
                let customerlenders = deepcopy(this.state.customerlenders)
                customerlenders.forEach((x) => {
                    if (x.name === name) {
                        x.Lastedit = new Date().toISOString()
                    }
                })
                savedLenders.push(name)
                this.setState({ savedLenders: savedLenders, customerlenders: customerlenders })
            }


            // return out;
            // The lender editor used to expand inline under its table row; it now opens
            // in a dialog, so the same form is rendered once for whichever row is open.
            let editingRecord = tableItems.find((r) => r.key === this.state.editingLenderKey)

            return (
                <>
                    {this.state.showManager ? selectLenders() :


                        <div>
                            {this.props.manager.open && <div>
                                <div className="mt-3 lendersHeadingWrap" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className='ModalTitle'>
                                        Add lenders
                                    </div>
                                    <div className="addLenderBtnOutline" onClick={() => {


                                        this.setState({ showManager: true, searchKeywords: "", selectedLenders: [] })
                                        this.props.updateSelectLender(false)


                                    }}>
                                        Add lender
                                    </div>
                                </div>

                                <div style={{ marginTop: 15, paddingBottom: 15 }}>
                                    You can always add additional lenders in <span style={{

                                        fontWeight: 600
                                    }}>
                                        Management {'>'} Lenders.

                                    </span>
                                </div>
                            </div>}

                            <Table
                                loading={this.state.tableLoading}
                                className="lendersTable"
                                columns={columns}
                                dataSource={tableItems.filter((x) => x.name.toLowerCase().includes(this.state.searchKeywords.toLowerCase()))}
                                showSorterTooltip={false}
                                pagination={false}
                                rowClassName="lendersTableRow"
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: () => handleExpand(record),
                                        onMouseEnter: () => {
                                            this.setState({ hoveredRowIndex: rowIndex })
                                        },
                                        onMouseLeave: () => {
                                            this.setState({ hoveredRowIndex: null })
                                        }
                                    }
                                }}
                            />
                        </div>
                    }
                    <LenderConfigDrawer
                        open={!!editingRecord}
                        record={editingRecord}
                        stateOptions={this.getStateOptions()}
                        logoMap={lendersLogoMap}
                        dirty={this.state.lenderEditDirty}
                        onClose={() => closeLenderEditor()}
                        onSave={() => editingRecord && handleSaveLender(editingRecord.name)}
                        onConfigChange={() => this.setState({ customerlenders: this.state.customerlenders, lenderEditDirty: true })}
                        onAddPromotion={(record) => {
                            let promotions = [deepcopy(emptypromotion)]
                            this.state.promotions[0].ref = React.createRef()
                            this.setState({ config: record.config, promotions: promotions, modalpromotionvalidated: false, showpromotion: true, mode: "add" })
                        }}
                        onAddAdjustment={(record) => {
                            let rules = [deepcopy(emptyrule)]
                            this.state.rules[0].ref = React.createRef()
                            this.setState({ config: record.config, rules: rules, modalvalidated: false, show: true, mode: "add" })
                        }}
                        formRef={editingRecord ? this.formRefs[editingRecord.name + "_table"] : null}
                        onSubmit={editingRecord ? this.handleTableFormSubmit(editingRecord) : undefined}
                        validated={this.state.validated}
                    />
                </>

            )

        }
        let add = (e) => {
            // let out = [];
            let lenders = []
            this.state.allenders.forEach((x) => {
                if (undefined === this.lendersid[x.id]) {
                    lenders.push(x)
                }
            })

            let selectedLenders = []
            let targets = deepcopy(this.state.editTarget)
            let expandedKeys = deepcopy(this.state.expandedRowKeys)
            lenders.forEach((x) => {
                if (this.state.selectedLenders.includes(x.name)) {
                    selectedLenders.push(x)
                    targets.push(x.name)
                    expandedKeys.push("row_" + x.lender)
                }
            })


            //  no need for now
            // if (selectedLenders.length === 0) {
            //   selectedLenders.push(lenders[0]);
            //   targets.push(lenders[0].name);
            //   expandedKeys.push(lenders[0].name);
            //   console.log(this.state.selectedid);
            //   console.log(lenders);
            // }
            this.setState({ editTarget: targets, showEdit: true, expandedRowKeys: expandedKeys })
            let lendersOnTop = []
            let lendersCopy = deepcopy(this.state.customerlenders)
            let selectedLenderCopy = selectedLenders

            // use historical config and filter out newly added historical lenders from newly add list
            for (let y of selectedLenders) {
                for (let x of lendersCopy) {
                    if (y.id === x.id && !x.Active) {
                        x.Active = true
                        lendersOnTop.push(x)
                        selectedLenderCopy = selectedLenderCopy.filter(lender => lender.id !== y.id)
                    }
                }
            }
            // filter out newly added historical lenders
            lendersCopy = lendersCopy.filter(lender => !lendersOnTop.some(lenderOnTop => lenderOnTop.id === lender.id))

            // assign default config to newly added fresh lenders
            for (let x of selectedLenderCopy) {
                x.Config = {
                    compensation: "1",
                    compensationFlatFee: 0,
                    closeover: null,
                    lenderfees: [
                        {
                            fee: 0,
                            feeFormat: 'flat', // Default to flat fee format
                            states: [],
                            mortgageTypes: [],
                        },
                    ],
                    maximumClosingCostPercentage: null,
                    minimumClosingCostPercentage: null,
                }
                if (this.state.lendercache[x.id] !== undefined) {
                    x.Config = this.state.lendercache[x.id]["Config"]
                }
            }
            for (let x of selectedLenderCopy) {
                let l = {
                    id: x.id,
                    name: x.name,
                    lender: x.lender,
                    Config: x.Config,
                    Active: true
                }
                lendersOnTop.push(l)
            }
            //keep newly added lenders on top
            lendersCopy = [...lendersOnTop, ...lendersCopy]

            this.resetLenderIDs(lendersCopy)
            this.setState({
                customerlenders: lendersCopy,
                justInsertedLenders: [
                    ...(this.state.justInsertedLenders || []),
                    ...lendersOnTop.map((x) => x.name),
                ],
            })



            this.props.updateLender(lendersCopy.filter(item => item.Active).length)


        }
        let showRules = (key) => {
            return (
                <option value={key} key={key}>
                    {com.RuleSet[key].name}
                </option>
            )
        }
        let displayRule = () => {
            let out = []
            out.push(displayRuleBody())
            out.push(displayAction())
            return out
        }

        let displayAction = () => {
            return (
                <>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{ marginBottom: "0" }}>Action:</Form.Label>
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    required
                                    type="text"
                                    value={this.state.action}
                                    onChange={(e) => {
                                        this.setState({ action: e.target.value })
                                    }}
                                    style={{ backgroundColor: "#FCFCFC" }}
                                >
                                    <option value="">...</option>
                                    <option value="adjustment">Set adjustment points</option>
                                    <option value="fail">Fail qualification</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    {this.state.action === "adjustment" ? (
                        <Row>
                            <Col>
                                <Form.Group controlId="action">
                                    <InputGroup size="sm">
                                        <Form.Control
                                            size="sm"
                                            required
                                            value={this.state.adjustment}
                                            onChange={(e) =>
                                                this.setState({ adjustment: e.target.value })
                                            }
                                            type="text"
                                            style={{ width: "3em" }}
                                            pattern="^[0...9-.]*$"
                                            placeholder="XX.X"
                                        />
                                        <InputGroup.Append>
                                            <InputGroup.Text
                                                className="pl-3"
                                                style={{ fontSize: "0.9em", lineHeight: "1.3" }}
                                                size="sm"
                                            >
                                                %
                                            </InputGroup.Text>
                                        </InputGroup.Append>

                                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            Please enter adjustment points
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                </>
            )
        }

        let displayRuleBody = (index) => {
            let selectedRule = this.state.rules[index].selectedRule
            let maxrule = this.state.rules[index].maxrule
            let minrule = this.state.rules[index].minrule
            let value = this.state.rules[index].value
            let values = this.state.rules[index].values
            let typ = this.state.rules[index].typ

            let enumValues = () => {
                let out = []
                Object.keys(com.RuleSet[selectedRule].values).forEach((key) => {
                    out.push(
                        <option value={key}>{com.RuleSet[selectedRule].values[key]}</option>
                    )
                })
                return out
            }

            if (selectedRule === "" || undefined === selectedRule) return ""

            let displayFloat = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                                pattern="^[0...9-.]+$"
                                placeholder="XXX.XX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }

            let displayInt = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                                pattern="^[0-9]+$"
                                placeholder="XXX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let displayString = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let displayDollars = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <InputGroup.Prepend>

                            </InputGroup.Prepend>
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "5em" }}
                                pattern="^[0-9,.]+$"
                                placeholder="XXX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let setRuleValue = (token) => {
                return (e) => {
                    this.state.rules[index][token] = e.target.value
                    this.setState({ rules: this.state.rules })
                }
            }
            let displayOperator = () => {
                if (undefined === selectedRule || "" === selectedRule) return ""

                let showOption = (op) => {
                    switch (com.RuleSet[selectedRule].typ) {
                        case "minmax":
                            return <option value={op}>{com.operatorInout[op]}</option>
                        case "enum":
                            return <option value={op}>{com.operatorEnum[op]}</option>
                        case "bool":
                            return <option value={op}>{com.operatorBool[op]}</option>
                        case "value":
                        default:
                            return <option value={op}>{com.operatorMap[op]}</option>
                    }
                }
                return (
                    <Col
                        xs="auto"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Form.Group>
                            <Form.Control
                                as="select"
                                size="sm"
                                required
                                type="text"
                                value={this.state.rules[index]["operator"]}
                                onChange={(e) => {
                                    this.state.rules[index]["operator"] = e.target.value
                                    this.setState({ rules: this.state.rules })
                                }}
                            >
                                <option value="">...</option>
                                {com.RuleSet[selectedRule].operators != null
                                    ? com.RuleSet[selectedRule].operators.map(showOption)
                                    : ""}
                            </Form.Control>
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                Enter comparison
                            </Form.Control.Feedback>{" "}
                        </Form.Group>
                    </Col>
                )
            }
            let getOptions = () => {
                let r = Object.keys(com.RuleSet[selectedRule].values).map((x) => {
                    return { name: com.RuleSet[selectedRule].values[x], id: x }
                })

                return r
            }
            let onSelect = (e) => {
                this.state.rules[index]["selectedEnum"] = e
                this.setState({ rules: this.state.rules })
            }
            let selectLeftOperator = (e) => {
                this.state.rules[index]["minoperator"] = e.target.value
                this.setState({ rules: this.state.rules })
            }
            let selecRightOperator = (e) => {
                this.state.rules[index]["maxoperator"] = e.target.value
                this.setState({ rules: this.state.rules })
            }

            let displayRightCondition = () => {
                return (
                    <Col xs="auto">
                        <Form.Group>
                            <Form.Control
                                as="select"
                                size="sm"
                                //defaultValue={this.props.firsttime}
                                type="select"
                                style={{ width: "5em" }}
                                required
                                value={this.state.rules[index]["maxoperator"]}
                                onChange={selecRightOperator}
                            >
                                <option key="defrule" value="">
                                    ...
                                </option>
                                <option key="less" value="less">
                                    &lt;
                                </option>
                                <option key="lessorequal" value="lessorequal">
                                    &lt;=
                                </option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                )
            }
            let displayLeftCondition = () => {
                return (
                    <Col xs="auto">
                        <Form.Group>
                            <Form.Control
                                as="select"
                                size="sm"
                                //defaultValue={this.props.firsttime}
                                type="select"
                                style={{ width: "5em" }}
                                required
                                value={this.state.rules[index]["minoperator"]}
                                onChange={selectLeftOperator}
                            >
                                <option key="defrule" value="">
                                    ...
                                </option>
                                <option key="less" value="less">
                                    &lt;
                                </option>
                                <option key="lessorequal" value="lessorequal">
                                    &lt;=
                                </option>
                            </Form.Control>
                        </Form.Group>{" "}
                    </Col>
                )
            }

            switch (com.RuleSet[selectedRule].typ) {
                case "minmax":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "minimumrange",
                                        minrule,
                                        setRuleValue("minrule"),
                                        "Enter Min"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "minimumrange",
                                            minrule,
                                            setRuleValue("minrule"),
                                            "Enter Min"
                                        )
                                        : com.RuleSet[selectedRule].values === "dollar"
                                            ? displayDollars(
                                                "minimumrange",
                                                minrule,
                                                setRuleValue("minrule"),
                                                "Enter Min"
                                            )
                                            : ""}
                            </Col>
                            {displayLeftCondition()}
                            <Col className="text-center">
                                <span className="mx-2 text-nowrap font-weight-bold">
                                    {com.RuleSet[selectedRule].short !== undefined
                                        ? com.RuleSet[selectedRule].short
                                        : com.RuleSet[selectedRule].name}
                                </span>
                            </Col>
                            {displayRightCondition()}
                            <Col>
                                {" "}
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "maximumrange",
                                        maxrule,
                                        setRuleValue("maxrule"),
                                        "Enter Max"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "maximumrange",
                                            maxrule,
                                            setRuleValue("maxrule"),
                                            "Enter Max"
                                        )
                                        : com.RuleSet[selectedRule].values === "dollar"
                                            ? displayDollars(
                                                "maximumrange",
                                                maxrule,
                                                setRuleValue("maxrule"),
                                                "Enter Max"
                                            )
                                            : ""}
                            </Col>
                        </Row>
                    )
                case "enum":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                <Multiselect
                                    ref={this.state.rules[index].ref}
                                    options={getOptions()}
                                    selectedValues={this.state.rules[index]["selectedEnum"]}
                                    displayValue="name"
                                    onSelect={onSelect}
                                    onRemove={onSelect}
                                />
                            </Col>
                        </Row>
                    )
                    break
                case "value":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "value",
                                        value,
                                        setRuleValue("value"),
                                        "Please enter value"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "value",
                                            value,
                                            setRuleValue("value"),
                                            "Please enter value"
                                        )
                                        : com.RuleSet[selectedRule].values === "string"
                                            ? displayString(
                                                "value",
                                                value,
                                                setRuleValue("value"),
                                                "Please enter value"
                                            )
                                            : com.RuleSet[selectedRule].values === "dollar"
                                                ? displayDollars(
                                                    "value",
                                                    value,
                                                    setRuleValue("value"),
                                                    "Please enter value"
                                                )
                                                : ""}
                            </Col>
                        </Row>
                    )
                case "bool":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col></Col>
                            <Col></Col>
                        </Row>
                    )
                default:
                    return selectedRule
            }
        }
        let displayPromotionBody = (index) => {
            let selectedRule = this.state.promotions[index].selectedRule
            let maxrule = this.state.promotions[index].maxrule
            let minrule = this.state.promotions[index].minrule
            let value = this.state.promotions[index].value
            let values = this.state.promotions[index].values
            let typ = this.state.promotions[index].typ

            let enumValues = () => {
                let out = []
                Object.keys(com.RuleSet[selectedRule].values).forEach((key) => {
                    out.push(
                        <option value={key}>{com.RuleSet[selectedRule].values[key]}</option>
                    )
                })
                return out
            }

            if (selectedRule === "" || undefined === selectedRule) return ""

            let displayFloat = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                                pattern="^[0...9-.]+$"
                                placeholder="XXX.XX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }

            let displayInt = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                                pattern="^[0-9]+$"
                                placeholder="XXX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let displayString = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "3em" }}
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let displayDollars = (id, value, onChange, feedback) => {
                return (
                    <Form.Group controlId={id}>
                        <InputGroup size="sm">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ fontSize: "0.9em" }} size="sm">
                                    $
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                size="sm"
                                name={id}
                                required
                                value={value}
                                onChange={onChange}
                                type="text"
                                style={{ width: "5em" }}
                                pattern="^[0-9,.]+$"
                                placeholder="XXX"
                            />
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {feedback}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                )
            }
            let setRuleValue = (token) => {
                return (e) => {
                    this.state.promotions[index][token] = e.target.value
                    this.setState({ promotions: this.state.promotions })
                }
            }
            let displayOperator = () => {
                if (undefined === selectedRule || "" === selectedRule) return ""

                let showOption = (op) => {
                    switch (com.RuleSet[selectedRule].typ) {
                        case "minmax":
                            return <option value={op}>{com.operatorInout[op]}</option>
                        case "enum":
                            return <option value={op}>{com.operatorEnum[op]}</option>
                        case "bool":
                            return <option value={op}>{com.operatorBool[op]}</option>
                        case "value":
                        default:
                            return <option value={op}>{com.operatorMap[op]}</option>
                    }
                }
                return (
                    <Col
                        xs="auto"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Form.Group>
                            <Form.Control
                                style={{ width: '120px' }}
                                as="select"
                                size="sm"
                                required
                                type="text"
                                value={this.state.promotions[index]["operator"]}
                                onChange={(e) => {
                                    this.state.promotions[index]["operator"] = e.target.value
                                    this.setState({ promotions: this.state.promotions })
                                }}
                            >
                                <option value="">...</option>
                                {com.RuleSet[selectedRule].operators != null
                                    ? com.RuleSet[selectedRule].operators.map(showOption)
                                    : ""}
                            </Form.Control>
                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                Enter comparison
                            </Form.Control.Feedback>{" "}
                        </Form.Group>
                    </Col>
                )
            }
            let getOptions = () => {
                let r = Object.keys(com.RuleSet[selectedRule].values).map((x) => {
                    return { name: com.RuleSet[selectedRule].values[x], id: x }
                })

                return r
            }
            let onSelect = (e) => {
                this.state.promotions[index]["selectedEnum"] = e
                this.setState({ promotions: this.state.promotions })
            }
            let selectLeftOperator = (e) => {
                this.state.promotions[index]["minoperator"] = e.target.value
                this.setState({ promotions: this.state.promotions })
            }
            let selecRightOperator = (e) => {
                this.state.promotions[index]["maxoperator"] = e.target.value
                this.setState({ promotions: this.state.promotions })
            }

            let displayRightCondition = () => {
                return (
                    <Col xs="auto">
                        <Form.Group>
                            <Form.Control
                                as="select"
                                size="sm"
                                //defaultValue={this.props.firsttime}
                                type="select"
                                style={{ width: "5em" }}
                                required
                                value={this.state.promotions[index]["maxoperator"]}
                                onChange={selecRightOperator}
                            >
                                <option key="defrule" value="">
                                    ...
                                </option>
                                <option key="less" value="less">
                                    &lt;
                                </option>
                                <option key="lessorequal" value="lessorequal">
                                    &lt;=
                                </option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                )
            }
            let displayLeftCondition = () => {
                return (
                    <Col xs="auto">
                        <Form.Group>
                            <Form.Control
                                as="select"
                                size="sm"
                                //defaultValue={this.props.firsttime}
                                type="select"
                                style={{ width: "5em" }}
                                required
                                value={this.state.promotions[index]["minoperator"]}
                                onChange={selectLeftOperator}
                            >
                                <option key="defrule" value="">
                                    ...
                                </option>
                                <option key="less" value="less">
                                    &lt;
                                </option>
                                <option key="lessorequal" value="lessorequal">
                                    &lt;=
                                </option>
                            </Form.Control>
                        </Form.Group>{" "}
                    </Col>
                )
            }

            switch (com.RuleSet[selectedRule].typ) {
                case "minmax":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "minimumrange",
                                        minrule,
                                        setRuleValue("minrule"),
                                        "Enter Min"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "minimumrange",
                                            minrule,
                                            setRuleValue("minrule"),
                                            "Enter Min"
                                        )
                                        : com.RuleSet[selectedRule].values === "dollar"
                                            ? displayDollars(
                                                "minimumrange",
                                                minrule,
                                                setRuleValue("minrule"),
                                                "Enter Min"
                                            )
                                            : ""}
                            </Col>
                            {displayLeftCondition()}
                            <Col className="text-center">
                                <span className="mx-2 text-nowrap font-weight-bold">
                                    {com.RuleSet[selectedRule].short !== undefined
                                        ? com.RuleSet[selectedRule].short
                                        : com.RuleSet[selectedRule].name}
                                </span>
                            </Col>
                            {displayRightCondition()}
                            <Col>
                                {" "}
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "maximumrange",
                                        maxrule,
                                        setRuleValue("maxrule"),
                                        "Enter Max"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "maximumrange",
                                            maxrule,
                                            setRuleValue("maxrule"),
                                            "Enter Max"
                                        )
                                        : com.RuleSet[selectedRule].values === "dollar"
                                            ? displayDollars(
                                                "maximumrange",
                                                maxrule,
                                                setRuleValue("maxrule"),
                                                "Enter Max"
                                            )
                                            : ""}
                            </Col>
                        </Row>
                    )
                case "enum":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                <Multiselect
                                    ref={this.state.promotions[index].ref}
                                    options={getOptions()}
                                    selectedValues={this.state.promotions[index]["selectedEnum"]}
                                    displayValue="name"
                                    onSelect={onSelect}
                                    onRemove={onSelect}
                                />
                            </Col>
                        </Row>
                    )
                    break
                case "value":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col>
                                {com.RuleSet[selectedRule].values === "float"
                                    ? displayFloat(
                                        "value",
                                        value,
                                        setRuleValue("value"),
                                        "Please enter value"
                                    )
                                    : com.RuleSet[selectedRule].values === "int"
                                        ? displayInt(
                                            "value",
                                            value,
                                            setRuleValue("value"),
                                            "Please enter value"
                                        )
                                        : com.RuleSet[selectedRule].values === "string"
                                            ? displayString(
                                                "value",
                                                value,
                                                setRuleValue("value"),
                                                "Please enter value"
                                            )
                                            : com.RuleSet[selectedRule].values === "dollar"
                                                ? displayDollars(
                                                    "value",
                                                    value,
                                                    setRuleValue("value"),
                                                    "Please enter value"
                                                )
                                                : ""}
                            </Col>
                        </Row>
                    )
                case "bool":
                    return (
                        <Row>
                            {displayOperator()}
                            <Col></Col>
                            <Col></Col>
                        </Row>
                    )
                default:
                    return selectedRule
            }
        }
        let modalSubmit = (event) => {
            if (this.modal.current.reportValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                this.setState({ modalvalidated: true })

                return false
            }
            event.preventDefault()
            event.stopPropagation()

            let tst = {}
            switch (this.state.action) {
                case "adjustment": {
                    tst.adjustment = this.state.adjustment
                    break
                }
                case "fail": {
                    tst.fail = true
                    break
                }
                default: {
                    alert("should not see this!")
                }
            }
            tst.rules = []

            this.state.rules.forEach((x) => {
                // set the config
                //create rule

                let rule = {}
                switch (com.RuleSet[x.selectedRule].typ) {
                    case "minmax":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = [x.minrule, x.maxrule]
                        rule[x.selectedRule].minoperator = x.minoperator
                        rule[x.selectedRule].maxoperator = x.maxoperator
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "enum":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = x.selectedEnum.map((x) => x.id)
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "value":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = x.value
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "bool":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = true
                        rule[x.selectedRule].operator = x.operator
                        break
                }

                tst.rules.push(rule)
            })

            if (this.state.mode === "edit") {
                this.state.config.rules[this.state.ruleindex] = tst
                this.state.rule = tst
            } else {
                if (this.state.config.rules == null) this.state.config.rules = []

                this.state.config.rules.push(tst)
            }

            this.setState({
                show: false,
                customerlenders: this.state.customerlenders,
            })
            this.trackMgmtLenders(
                this.state.mode === "edit"
                    ? STATSIG.LENDERS.ADJUSTMENT_UPDATE
                    : STATSIG.LENDERS.ADJUSTMENT_INSERT
            )
            return false
        }
        let displayPromotionBox = (rule, i) => {
 
         
            
            let selectPromotion = (e) => {
             
                this.state.promotions[i].selectedRule = e.target.value
                this.setState({ promotions: this.state.promotions })
                if (this.state.promotions[i].ref == null) {
                    this.state.promotions[i].ref = React.createRef()
                }

                if (null != this.state.promotions[i].ref.current) {
                    setTimeout((e) => {
                        if (this.state.promotions[i].ref.current != null)
                            this.state.promotions[i].ref.current.resetSelectedValues()

                    }, 200)
                }
            }
            let remove = () => {
                this.state.promotions.splice(i, 1)
                this.setState({ promotions: this.state.promotions })
            }

            return (
                <div className="rulecard mb-2" key={"displayRuleBox" + i}>
                    {this.state.promotions.length > 1 ? (
                        <Row>
                            <Col className="text-right pt-0 pr-1">
                                <i
                                    className="far fahover fa-minus-square text-primary aligh-top fa-1x divlink"
                                    onClick={remove}
                                ></i>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{ marginBottom: "10px" }}>
                                    Condition:
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    style={{width:'120px'}}
                                    defaultValue={this.state
                                        .promotions.selectedRule}
                                    type="select"
                                    required
                                    value={rule.selectedRule}
                                    onChange={selectPromotion}
                                >
                                    <option key="defrule" value="">
                                        Please select...
                                    </option>
                                    {Object.keys(com.RuleSet).map(showRules)}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    {rule.selectedRule!==''? displayPromotionBody(i) : ""}
                </div>
            )
        }
        let addMorePromotion = () => {
            let newpromotion = deepcopy(emptypromotion)
            newpromotion.ref = React.createRef()
            this.state.promotions.push(newpromotion)
            this.setState({ promotions: this.state.promotions })
        }
        let displayRuleBox = (rule, i) => {
            let selectRule = (e) => {
                this.state.rules[i].selectedRule = e.target.value
                this.setState({ rules: this.state.rules })
                if (this.state.rules[i].ref == null) {
                    this.state.rules[i].ref = React.createRef()
                }

                if (null != this.state.rules[i].ref.current) {
                    setTimeout((e) => {
                        if (this.state.rules[i].ref.current != null)
                            this.state.rules[i].ref.current.resetSelectedValues()

                    }, 200)
                }
            }
            let remove = () => {
                this.state.rules.splice(i, 1)
                this.setState({ rules: this.state.rules })
            }

            return (
                <div className="rulecard mb-2" key={"displayRuleBox" + i}>
                    {this.state.rules.length > 1 ? (
                        <Row>
                            <Col className="text-right pt-0 pr-1">
                                <i
                                    className="far fahover fa-minus-square text-primary aligh-top fa-1x divlink"
                                    onClick={remove}
                                ></i>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label style={{ marginBottom: "10px" }}>
                                    Condition:
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    //defaultValue={this.props.firsttime}
                                    type="select"
                                    required
                                    value={rule.selectedRule}
                                    onChange={selectRule}
                                >
                                    <option key="defrule" value="">
                                        Please seclect...
                                    </option>
                                    {Object.keys(com.RuleSet).map(showRules)}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    {this.state.rules[i].selectedRule !== "" ? displayRuleBody(i) : ""}
                </div>
            )
        }
        let addMore = () => {
            let newrule = deepcopy(emptyrule)
            newrule.ref = React.createRef()
            this.state.rules.push(newrule)
            this.setState({ rules: this.state.rules })
        }
        let copyOptions = () => {
            let out = []
            this.state.customerlenders.forEach((x) => {
                if (x.id === this.state.lenderid) return
                out.push(<option value={x.id}> {x.name} </option>)
            })
            return out
        }
        let modalCopySubmit = (event) => {
            if (this.modalcopy.current.reportValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                this.setState({ modalcopyvalidated: true })

                return false
            }
            event.preventDefault()
            event.stopPropagation()

            this.state.customerlenders.forEach((x) => {
                if (x.id.toString() === this.state.targetcopy) {
                    //alert(this.state.targetcopy)
                    x.Config.rules = deepcopy(this.state.config.rules)
                    x.Config.promotions = deepcopy(this.state.config.promotions)
                }
            })

            this.setState({
                showcopy: false,
                customerlenders: this.state.customerlenders,
            })
            return false
        }
        let modalPromotionSubmit = (event) => {
            if (this.promotionmodal.current.reportValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                this.setState({ modalpromotionvalidated: true })

                return false
            }
            event.preventDefault()
            event.stopPropagation()

            let tst = {}
            tst.conditions = []
            tst.message = this.state.message
console.log(
    this.state.promotions);

            this.state.promotions.forEach((x) => {
                // set the config
                //create rule
                let rule = {}
                switch (com.RuleSet[x.selectedRule].typ) {
                    case "minmax":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = [x.minrule, x.maxrule]
                        rule[x.selectedRule].minoperator = x.minoperator
                        rule[x.selectedRule].maxoperator = x.maxoperator
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "enum":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = x.selectedEnum.map((x) => x.id)
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "value":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = x.value
                        rule[x.selectedRule].operator = x.operator
                        break
                    case "bool":
                        rule[x.selectedRule] = {}
                        rule[x.selectedRule].value = true
                        rule[x.selectedRule].operator = x.operator
                        break
                }

                tst.conditions.push(rule)
            })

            if (this.state.mode === "edit") {
                this.state.config.promotions[this.state.promotionindex] = tst

            } else {
                if (this.state.config.promotions == null) this.state.config.promotions = []

                this.state.config.promotions.push(tst)
            }

            this.setState({
                showpromotion: false,
                customerlenders: this.state.customerlenders,
            })
            this.trackMgmtLenders(
                this.state.mode === "edit"
                    ? STATSIG.LENDERS.PROMOTION_UPDATE
                    : STATSIG.LENDERS.PROMOTION_INSERT
            )
            return false
        }


        const sendMsgToSlack = () => {

            let token = sessionStorage.getItem("ZeitroA")

            fetch("/los/addlenderrequest", {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                },
            }).then((response) => {
                if (response.status !== 200) {
                    console.log(
                        "/los/addlenderrequest: Looks like there was a problem. Status Code: " +
                        response.status
                    )
                    return
                }
                this.trackMgmtLenders(STATSIG.LENDERS.REQUEST)
            })
        }

        let modalAddLenderSubmit = (event) => {
            if (this.addLenderModal.current.reportValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                this.setState({ modalAddLenderValidated: true })

                return false
            }
            event.preventDefault()
            event.stopPropagation()
            add()
            this.setState({
                showAdd: false,
            })
            if (this.props.manager) {
                this.props.updateSelectLender(true)

                this.setState({
                    showManager: false,
                })
            }
            return false
        }

        return (
            <div className="text-left lendersPane" style={this.props.manager.open && this.state.showManager ? { padding: '0px 20px' } : {}}>
                {
                    this.props.isManager ? <div>

                    </div> : <div>

                        <div className="lendersPageHead">
                            <div>
                                <div className="lendersPageTitle">Lenders</div>
                                <div className="lendersPageSubtitle">
                                    {this.state.customerlenders.filter((x) => x.Active).length} lender{this.state.customerlenders.filter((x) => x.Active).length === 1 ? "" : "s"} connected · pricing from these lenders appears in your rate quotes
                                </div>
                            </div>
                            <button
                                type="button"
                                className="lendersAddBtn"
                                onClick={() => {
                                    this.trackMgmtLenders(STATSIG.LENDERS.ADD_LENDER_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                                    this.setState({ showAdd: true, searchKeywords: "", selectedLenders: [] })
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>
                                Add lenders
                            </button>
                        </div>
                        <div className="lendersSearchWrap">
                            <Input
                                className="lendersInputSearch"
                                prefix={this.search_svg()}
                                placeholder="Search lenders"
                                value={this.state.searchKeywords}
                                onSearch={(value) => this.handleSearch(value)}
                                onChange={(e) => this.handleSearchChange(e)}
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                allowClear
                            />
                        </div>
                    </div>

                }
                <Modal
                    dialogClassName="addAdjustmentDialog"
                    show={this.state.show}
                    onHide={(e) => {
                        this.setState({ show: false })
                    }}
                    className="addAdjustmentModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.mode === "edit" ? (
                                <>Edit an adjustment</>
                            ) : (
                                <>Add an adjustment</>
                            )}
                        </Modal.Title>
                    </Modal.Header>
                    <Form
                        ref={this.modal}
                        onSubmit={modalSubmit}
                        noValidate
                        validated={this.state.modalvalidated}
                        className="addAdjustmentModalForm"
                    >
                        <Modal.Body>
                            <div className="d-flex h-100">
                                <div className="conditionSection">
                                    {this.state.rules.map(displayRuleBox)}
                                    <hr />
                                    <Row>
                                        <Col className="text-left">
                                            <Button onClick={addMore} variant="link" className="pl-0">
                                                Add condition
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="actionSection">
                                    {this.state.selectedRule !== "" ? displayAction() : ""}
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer className="text-center d-block">
                            <Row className="text-center">
                                <Col className="d-flex align-items-center">
                                    <div
                                        className="adjustmentCancelBtn"
                                        onClick={(e) => {
                                            this.setState({ show: false })
                                        }}
                                    >
                                        Cancel
                                    </div>
                                </Col>
                                <Col className="d-flex align-items-center text-right justify-content-end">
                                    <Button type="submit" className="adjustmentSubmitBtn">
                                        {this.state.mode === "edit" ? "Update" : "Add"}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Form>
                </Modal>
                <Modal
                    dialogClassName="modal-50w"
                    show={this.state.showcopy}
                    onHide={(e) => {
                        this.setState({ showcopy: false })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Copy adjustment rules from {this.state.lendername}
                        </Modal.Title>
                    </Modal.Header>
                    <Form
                        ref={this.modalcopy}
                        onSubmit={modalCopySubmit}
                        noValidate
                        validated={this.state.modalcopyvalidated}
                    >
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label style={{ marginBottom: "0" }}>To:</Form.Label>
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    required
                                    type="text"
                                    //value={this.state.action}

                                    onChange={(e) => {
                                        this.setState({ targetcopy: e.target.value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {copyOptions()}
                                </Form.Control>
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer className="text-center d-block">
                            <Row className="text-center">
                                <Col>
                                    <Button
                                        onClick={(e) => {
                                            this.setState({ showcopy: false })
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                                <Col>
                                    <Button variant="success" type="submit">
                                        Copy
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Form>
                </Modal>
                <Modal
                    dialogClassName="addPromotionDialog"
                    show={this.state.showpromotion}
                    onHide={(e) => {
                        this.setState({ showpromotion: false })
                    }}
                    className="addPromotionModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.mode === "edit" ? (
                                <>Edit promotion</>
                            ) : (
                                <>Add promotion</>
                            )}
                        </Modal.Title>
                    </Modal.Header>
                    <Form
                        ref={this.promotionmodal}
                        onSubmit={modalPromotionSubmit}
                        noValidate
                        validated={this.state.modalpromotionvalidated}
                        className="addPromotionModalForm"
                    >
                        <Modal.Body>
                            <div className="d-flex h-100">
                                <div className="conditionSection">
                                    {this.state.promotions.map(displayPromotionBox)}
                                    <hr />
                                    <Row>
                                        <Col className="text-left">
                                            <Button onClick={addMorePromotion} variant="link" className="pl-0">
                                                Add more
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="actionSection">
                                    {this.state.selectedRule !== "" ? <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label style={{ marginBottom: "10px" }}>Promotion message:</Form.Label>
                                                <Form.Control
                                                    size="sm"
                                                    required
                                                    type="text"
                                                    value={this.state.message}
                                                    onChange={(e) => {
                                                        this.setState({ message: e.target.value })
                                                    }}
                                                    placeholder="Please enter message here"
                                                    style={{ minHeight: "120px", backgroundColor: "#FCFCFC", border: "1px solid #DBDCDE", borderRadius: "4px" }}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row> : ""}
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer className="text-center d-block">
                            <Row className="text-center">
                                <Col className="d-flex align-items-center">
                                    <div
                                        className="adjustmentCancelBtn"
                                        onClick={(e) => {
                                            this.setState({ showpromotion: false })
                                        }}
                                    >
                                        Cancel
                                    </div>
                                </Col>
                                <Col className="d-flex align-items-center text-right justify-content-end">
                                    <Button type="submit" className="adjustmentSubmitBtn">
                                        {this.state.mode === "edit" ? "Update" : "Add"}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <AddLendersModal
                    open={this.state.showAdd}
                    onClose={() => this.setState({ showAdd: false, searchKeywords: "" })}
                    catalog={this.getAvailableLenders()}
                    stateOptions={this.getStateOptions()}
                    logoMap={lendersLogoMap}
                    saving={this.state.addLendersSaving}
                    onSave={this.addAndSaveLenders}
                    footerLeft={
                        this.props.subscriptionReducer.plan === 'business' || this.props.subscriptionReducer.plan === 'enterprise' || this.props.subscriptionReducer.plan === 'originator' ? (
                            <Popconfirm
                                id="addLenderRequest"
                                title="Would you like to send a request to add lenders to the Zeitro team?"
                                description="After submitting your request, Zeitro will reach out to you with instructions on how to add additional lenders to the system. We may require your assistance in obtaining the necessary information for these lenders."
                                onConfirm={() => {
                                    sendMsgToSlack()
                                    message.success("Your request has been sent, and the Zeitro team will contact you soon.")
                                }}
                                onCancel={() => { }}
                                okText="Send request"
                                placement="top"
                                overlayStyle={{ width: 400 }}
                                cancelText="Cancel"
                                icon={<InfoCircleTwoTone />}
                            ><span className="alm-link-btn" style={{ fontSize: 13 }}>Can't find your lender?</span></Popconfirm>
                        ) : (
                            <Popconfirm
                                id="addLenderRequest"
                                title="This feature is available on the Individual Plan. To add lenders that aren't currently in our system, please upgrade to the Individual Plan."
                                onConfirm={() => {
                                    // 关闭 add lender 弹窗并打开 UpgradeToBusinessModal
                                    this.setState({
                                        showAdd: false,
                                    })
                                    sessionStorage.setItem('path', 'Pricing')

                                    // 检查当前是否在 management 路由下（包括子路由）
                                    if (this.props.location.pathname.includes('/app/management')) {
                                        // 如果在 management 路由下，使用菜单切换
                                        this.props.toPricing()
                                    } else {
                                        // 如果不在 management 路由下，使用 window.open
                                        window.open('/app/management', '_self')
                                    }
                                }}
                                onCancel={() => { }}
                                okText="Upgrade now"
                                placement="top"
                                overlayStyle={{ width: 400 }}
                                cancelText="Cancel"
                                icon={<InfoCircleTwoTone />}
                            ><span className="alm-link-btn" style={{ fontSize: 13 }}>Can't find your lender?</span></Popconfirm>
                        )
                    }
                />
                <PlanModal isModalOpen={this.state.isModalOpen} closeModal={() => {

                    this.setState({ isModalOpen: false })

                }} ></PlanModal>
                
                <UpgradeToBusinessModal
                    isOpen={this.state.isUpgradePlanModalOpen}
                    onClose={() => {
                        this.setState({ isUpgradePlanModalOpen: false })
                    }}
                    onUpgrade={() => {
                        this.setState({ isUpgradePlanModalOpen: false })
                        sessionStorage.setItem('path', 'Pricing')
                        
                        // 检查当前是否在 management 路由下（包括子路由）
                        if (this.props.location.pathname.includes('/app/management')) {
                            // 如果在 management 路由下，使用菜单切换
                            this.props.toPricing()
                        } else {
                            // 如果不在 management 路由下，使用 window.open
                            window.open('/app/management', '_self')
                        }
                    }}
                />
                
                {showLenders()}

                {/* <EditLenderModal 
                    isOpen={this.state.showEditModal}
                    lenders={this.state.currentEditLender} 
                    minimumClosingCostPercentage={this.state.minimumClosingCostPercentage}
                    maximumClosingCostPercentage={this.state.maximumClosingCostPercentage}
                    customerlenders={this.state.customerlenders}
                    actions={{
                        statsigClient: this.props.statsigClient,
                        handleClose: this.handleCloseEditModal,
                        handleSaveLender: handleSaveLender,
                        handleAddPromotion: (record) => {
                            let promotions = [deepcopy(emptypromotion)]
                            this.state.promotions[0].ref = React.createRef()
                            this.setState({
                                config: record.config,
                                promotions: promotions,
                                modalpromotionvalidated: false,
                                showpromotion: true,
                                mode: "add",
                            })
                        },
                        handleAddAdjustment: (record) => {
                            let rules = [deepcopy(emptyrule)]
                            this.state.rules[0].ref = React.createRef()
                            this.setState({
                                config: record.config,
                                rules: rules,
                                modalvalidated: false,
                                show: true,
                                mode: "add",
                            })
                        }
                    }} 
                /> */}
            </div>
        )
    }

    handleCloseEditModal = () => {
        this.setState({
            showEditModal: false,
            currentEditLender: null
        });
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Lenders))
